import { useEffect, useRef, useState } from 'react'
import { useView } from '@10000/react'
import { Box, Button } from '../widgets'
import { PriceCard, PriceSelect, SubscriptionFeatures } from './'
import { enterprise, partner, subscriptionTypes, subscriptions, typePricing, isFree } from '../../lookups'
import './SubscriptionSelect.scss'

export const SubscriptionSelect = ({ onSubscriptionSelected, dark, onPartnerChanged, row }) => {
  const { partnerRequest, subscription: { index } }  = useView('tenant')
  const { type, teams } = subscriptions[index] || {}

  const itemRefs = useRef(Array.from({
    length: Object.entries(subscriptionTypes).length
  }))

  const [subscriptionType, setSubscriptionType] = useState(
    (index !== undefined && !isFree({ index })) ? type : 'single'
  )
  const [teamsSelected, setTeamsSelected] = useState(
    (index !== undefined) ? typePricing[type].findIndex(x => teams === x.teams) : 0
  )

  const subscriptionSelected = (id, index) => {
    setSubscriptionType(subscriptions[id].type)
    onSubscriptionSelected(id)
    setTeamsSelected(0) // teamsSelected is set to zero (for mobile & desktop compatibility) as the PriceSelect below needs to be synchronised with the onClick reset
    document.getElementById(index + "-price-card")?.scrollIntoView({ block: "center", inline: "center", behavior: "smooth" })
  }

  const checkCenter = () => {
    if(window.innerWidth < 600) {
      const viewportMiddle = window.innerWidth / 2
      itemRefs.current.forEach((ref, index) => {
        if(ref) {
          const rect = ref.getBoundingClientRect();
          const elementMiddle = rect.left + rect.width / 2

          const threshold = window.innerWidth / 2 // pixels of tolerance
          if (Math.abs(viewportMiddle - elementMiddle) < threshold) {
            const type = Object.entries(subscriptionTypes)[index][0]
            setSubscriptionType(type)
            onSubscriptionSelected(typePricing[type][0].id)
            document.getElementById(index + "-price-card")?.scrollIntoView({ block: "center", inline: "center", behavior: "smooth" })
          }
        }
      })
    }
  }

  useEffect(() => {
    if(window.innerWidth < 600){
      const index = Object.entries(subscriptionTypes).findIndex(x => x[0] === subscriptionType)
      document.getElementById(index + "-price-card")?.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" })
    }
  }, [subscriptionType])

  return <Box column gap={24} fullWidth container>
    <Box column fullWidth gap={16}>
      <Box column gap={32}>
        <Box
          className={`price-card-slider ${row ? 'slider-row' : ''}`}
          id="price-card-scroller"
          onMouseUp={checkCenter}
          onTouchEnd={checkCenter}
        >
          {Object.entries(subscriptionTypes).map(([key, value], index) =>
            <PriceCard
              key={key}
              type={key}
              name={value.title}
              id={index + "-price-card"}
              startingCost={value?.startingCost}
              description={value?.description}
              selected={subscriptionType === key}
              defaultTeam={teamsSelected}
              onSubscriptionSelected={(id) => subscriptionSelected(id, index)}
              showPricing={(key !== 'partner' || partnerRequest) && key !== 'free'}
            >
              {(key === 'partner' && !partnerRequest) &&
                <Box className="desktop-only" pb={16}>
                  <Button onClick={() => onPartnerChanged(true)}>Learn more</Button>
                </Box>
              }
              <Box
                height={0}
                fullWidth
                mt={-16}
                ref={card => itemRefs.current[index] = card}
              />
            </PriceCard>
          )}
        </Box>

        {(subscriptionType === 'enterprise' || (subscriptionType === 'partner' && partnerRequest)) &&
          <Box className="mobile-only">
            <PriceSelect
              value={teamsSelected}
              onTeamOptionSelected={(value) => {
                setTeamsSelected(value)
                onSubscriptionSelected((subscriptionType === 'enterprise' ? enterprise : partner)[value].id)
              }}
              dark={dark}
              pricing={subscriptionType === 'enterprise' ? enterprise : partner}
            />
          </Box>
        }
      </Box>
    </Box>

    <Box className="mobile-only">
      <SubscriptionFeatures
        subscriptionType={subscriptionType}
        dark={dark}
      />
    </Box>

    {(subscriptionType === 'partner' && !partnerRequest) &&
      <Box className="mobile-only">
        <Button onClick={() => onPartnerChanged(true)}>Learn more</Button>
      </Box>
    }
  </Box>
}